import Button from "@mui/material/Button";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import SearchIcon from "@mui/icons-material/Search";
import { BODY_ROW_SX, CLICKABLE_ROW_SX } from "../DailyExpense/tableStyles";
import { formatBusinessDate } from "../DailyExpense/format";
import FigureCells from "./FigureCells";
import { ReportLine, Thresholds, tonesOf } from "./incomeExpenseReport";
import { NAME_CELL_SX, NUMBER_CELL_SX } from "./reportTableStyles";

interface ReportTableRowProps {
  index: number;
  line: ReportLine;
  thresholds: Thresholds | null;
  isEstimate: boolean;
  showsMissingDocument: boolean;
  /** Branch and route lines drill one level down from their name. */
  onDrill?: (line: ReportLine) => void;
  /** Day lines open the drawer. */
  onOpen?: (line: ReportLine) => void;
}

/** One branch, route or day of the report. */
export default function ReportTableRow({
  index,
  line,
  thresholds,
  isEstimate,
  showsMissingDocument,
  onDrill,
  onOpen,
}: Readonly<ReportTableRowProps>) {
  const handleDrill = () => onDrill?.(line);
  const handleOpen = () => onOpen?.(line);
  const dayText = line.businessDate ? formatBusinessDate(line.businessDate) : line.workDayCount;

  return (
    <TableRow
      sx={onOpen ? CLICKABLE_ROW_SX : BODY_ROW_SX}
      onClick={onOpen ? handleOpen : undefined}
    >
      <TableCell align="center" sx={NUMBER_CELL_SX}>
        {index + 1}
      </TableCell>
      <TableCell sx={NAME_CELL_SX}>
        {onDrill ? (
          <Button
            size="small"
            onClick={handleDrill}
            endIcon={<SearchIcon fontSize="small" />}
            sx={{ p: 0, minWidth: 0, fontWeight: 600, textAlign: "left" }}
          >
            {line.label}
          </Button>
        ) : (
          line.label
        )}
      </TableCell>
      <TableCell align="right">{dayText}</TableCell>
      <FigureCells
        figures={line.figures}
        tones={tonesOf(line.figures, thresholds)}
        isEstimate={isEstimate}
        showsMissingDocument={showsMissingDocument}
        profitTrend={line.profitTrend}
      />
    </TableRow>
  );
}
